<template>

  <v-list dense>

    <!-- Back -->
    <v-list-item @click="$emit('back')">
      <v-list-item-icon>
        <v-icon disabled>mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Overlays</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <!-- Show All -->
    <v-list-item 
      v-if      = "!areAnyOverlaysEnabled"
      @click    = "onEnableAllOverlays"
    >
      <v-list-item-action>
        <v-checkbox :input-value="false"></v-checkbox>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Show All</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <!-- Hide All -->
    <v-list-item 
      v-else
      @click    = "onDisableAllOverlays"
    >
      <v-list-item-action>
        <v-checkbox :input-value="true"></v-checkbox>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Hide All</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item-group
      multiple
      :value    = "video.overlays"
      @change   = "onSetActiveOverlays"
    >

      <v-list-item
        v-for   = "type in overlays"
        color   = "primary"
        :key    = "type.key"
        :value  = "type.key"
      >
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ type.name }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list-item-group>

  </v-list>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { SELECT_OVERLAYS } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  name:     'OverlaysMenu',
  computed: {
    ...mapState([
      'video'
    ]),
    overlays() {
      return [
        {name: 'Action Safe', key: 'action_safe'},
        {name: 'Title Safe', key: 'title_safe'},
        {name: 'Action Safe (4:3)', key: 'action_safe_4x3'},
        {name: 'Title Safe (4:3)', key: 'title_safe_4x3'},
        {name: 'Action Safe (16:9)', key: 'action_safe_16x9'},
        {name: 'Title Safe (16:9)', key: 'title_safe_16x9'},
        {name: 'Action Safe (1.85:1)', key: 'action_safe_1_85x1'},
        {name: 'Title Safe (1.85:1)', key: 'title_safe_1_85x1'}
      ];
    },
    areAnyOverlaysEnabled() {
      return this.video.overlays.length > 0;
    }

  },

  // #endregion Properties

  // #region Events

  methods: {
    onSetActiveOverlays(overlays) {
      this.$store.dispatch(SELECT_OVERLAYS, overlays);
    },

    onEnableAllOverlays() {
      this.$store.dispatch(SELECT_OVERLAYS, this.overlays.map(o => o.key));
    },

    onDisableAllOverlays() {
      this.$store.dispatch(SELECT_OVERLAYS, []);
    }
  }

  // #endregion Events

}

</script>
